/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spicy_Just_Cheetah_ComfortInputs */

const fr_spicy_just_cheetah_comfort = /** @type {(inputs: Spicy_Just_Cheetah_ComfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de téléphone`)
};

/**

* @param {Spicy_Just_Cheetah_ComfortInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spicy_just_cheetah_comfort = /** @type {((inputs?: Spicy_Just_Cheetah_ComfortInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spicy_Just_Cheetah_ComfortInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spicy_just_cheetah_comfort(inputs)
});